<div class="width-100 pad-20 flex align-c justify-c" style="height: 90%;">
  <div style="width: 350px;">
    <div class="empty-status-a" [style.backgroundPosition]="data?.bg_position"></div>
    <div *ngIf="type != 'vessel_schedule' && type != 'rate_search_vessel'" style="line-height: 24px;"
      class="head-c font-16 flex align-c justify-c pad-tb-10 mar-t-5 text-a-c {{type == 'rate_search' ? 'width-res':''}}">
      {{data?.description}}</div>
    <div *ngIf="type == 'rate_search_vessel'" style="line-height: 24px;"
      class="head-c font-16 flex align-c justify-c pad-tb-10 mar-t-5 text-a-c width-res-ves">
      {{data?.description}}</div>
    <!-- rate -->
    <!-- <div *ngIf="type == 'rate_search'" class="font-14 pad-tb-10 mar-t-5 width-res text-a-c">
      <div class="f-w-500 mar-b-10 font-16">We are sold out for the above port pairs</div>
      <div class="mar-b-5">Please WhatsApp us at <a target="_blank"
          href="https://api.whatsapp.com/send?phone=918925962780&text=Hi..I need a rate for this particular POL:{{getObj?.from?.location_name}} and POD:{{getObj?.to?.location_name}}">+91 8925 962 780 </a>
        or email
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=csindia@atmavaan.com&su=Requesting a rate - reg&body=Port pairs that I have selected POL : {{getObj?.from?.location_name}}, POD : {{getObj?.to?.location_name}}, Cargo Ready Date : {{getObj?.cargo_ready_date | date}}"
          target="_blank">csindia{{'@'}}atmavaan.com</a> with</div>
      <div>your cargo availability date and port pair and we will revert back with availability.</div>
    </div> -->
    <!-- vessel -->
    <div *ngIf="type == 'vessel_schedule'" class="font-14 pad-tb-10 mar-t-5 width-res text-a-c">
      <div *ngIf="getObj?.from == null || getObj?.to == null" class="mar-b-10 font-16">
        <div>To obtain your schedule, simply insert (type ahead) your origin and the destination.</div>
        <div class="mar-t-5">By default, required time range is set to two weeks starting on the current date.</div>
      </div>
      <div *ngIf="getObj?.from !== null && getObj?.to !== null" class="mar-b-10 font-16" style="line-height: 24px;">No
        vessel schedule found for the selected criteria. Please adjust your search parameters. Our team will assist you
        shortly.</div>
    </div>
    <div class="sub-c font-14 flex align-c justify-c" style="text-align:center;" *ngIf="!!data?.sec_des">
      {{data?.sec_des}}</div>
  </div>
</div>